import { Link } from "react-router-dom";
import { Lock } from "lucide-react";
import { Reveal } from "../Reveal";

const ITEMS = [
  { src: "/img/p2.jpg", tier: "VIP" },
  { src: "/img/p3.jpg", tier: "Inner Circle" },
  { src: "/img/p5.jpg", tier: "VIP" },
];

export const Teaser = () => (
  <section data-testid="teaser-section" className="max-w-[1400px] mx-auto px-5 sm:px-8 py-24 sm:py-32">
    <Reveal className="flex flex-col sm:flex-row sm:items-end justify-between gap-6 mb-12">
      <div>
        <p className="eyebrow mb-5">03 — Behind the door</p>
        <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl text-[#0E1B3D]">Some things are <span className="italic text-[#D7263D]">only for members.</span></h2>
      </div>
      <Link to="/auth?mode=signup" data-testid="teaser-join-btn" className="ghost-btn px-6 py-3 text-xs tracking-[0.18em] uppercase self-start sm:self-auto">Unlock the feed</Link>
    </Reveal>
    <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
      {ITEMS.map((it, i) => (
        <Reveal key={i} delay={i * 0.1}>
          <div data-testid={`teaser-card-${i}`} className="relative aspect-[4/5] overflow-hidden border border-[#0E1B3D]/[0.08] group">
            <img src={it.src} alt="" className="absolute inset-0 w-full h-full object-cover blur-2xl scale-125 brightness-75" />
            <div className="absolute inset-0 bg-[#FFF8EE]/40" />
            <div className="absolute inset-0 flex flex-col items-center justify-center gap-4 text-center p-6">
              <span className="w-14 h-14 rounded-full border border-[#D7263D]/60 grid place-items-center transition-transform duration-500 group-hover:scale-110">
                <Lock className="w-5 h-5 text-[#D7263D]" />
              </span>
              <p className="font-mono-x text-xs tracking-[0.22em] uppercase text-[#0E1B3D]">{it.tier} members</p>
            </div>
          </div>
        </Reveal>
      ))}
    </div>
  </section>
);
